import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const PersonRemove = forwardRef<SVGSVGElement | null, IconFilledProps>(function PersonRemove({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17 8C17 10.2091 15.2091 12 13 12C10.7909 12 9 10.2091 9 8C9 5.79086 10.7909 4 13 4C15.2091 4 17 5.79086 17 8ZM15.5 8C15.5 9.38071 14.3807 10.5 13 10.5C11.6193 10.5 10.5 9.38071 10.5 8C10.5 6.61929 11.6193 5.5 13 5.5C14.3807 5.5 15.5 6.61929 15.5 8Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.5 16.8226C21.5 16.3835 21.2992 15.97 20.9579 15.7065C16.2421 12.0656 9.7579 12.0656 5.04212 15.7065C4.70085 15.97 4.5 16.3835 4.5 16.8226V18.75C4.5 19.3023 4.94772 19.75 5.5 19.75H20.5C21.0523 19.75 21.5 19.3023 21.5 18.75V16.8226ZM5.95714 18.25V16.8752C10.1378 13.6761 15.8622 13.6761 20.0429 16.8752V18.25H5.95714Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M2.5 5.25C2.22386 5.25 2 5.47386 2 5.75V6.25C2 6.52614 2.22386 6.75 2.5 6.75L7.5 6.75C7.77614 6.75 8 6.52614 8 6.25V5.75C8 5.47386 7.77614 5.25 7.5 5.25L2.5 5.25Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17 8C17 10.2091 15.2091 12 13 12C10.7909 12 9 10.2091 9 8C9 5.79086 10.7909 4 13 4C15.2091 4 17 5.79086 17 8Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.5 16.8226C21.5 16.3835 21.2992 15.97 20.9579 15.7065C16.2421 12.0656 9.7579 12.0656 5.04212 15.7065C4.70085 15.97 4.5 16.3835 4.5 16.8226V18.75C4.5 19.3023 4.94772 19.75 5.5 19.75H20.5C21.0523 19.75 21.5 19.3023 21.5 18.75V16.8226Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M2.5 5.25C2.22386 5.25 2 5.47386 2 5.75V6.25C2 6.52614 2.22386 6.75 2.5 6.75L7.5 6.75C7.77614 6.75 8 6.52614 8 6.25V5.75C8 5.47386 7.77614 5.25 7.5 5.25L2.5 5.25Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'person-remove-icon-svg'} iconRender={iconRender} {...props} />;
});

export default PersonRemove;
